// Firebase configuration for Legwork.
//
// EMPTY BY DESIGN. Every module that touches Firebase checks isConfigured()
// first and returns immediately, so an unconfigured app loads no third-party
// script, makes no request, and shows no sign-in UI. Filling this in is what
// turns the feature on.
//
// These values are public by design — they identify your project, they do not
// authorise anything. Access is controlled by your security rules.

export const firebaseConfig = {
  apiKey: 'AIzaSyBEL2UlCsZ2StvjvVPGSLYP96QcG2iBPaQ',
  authDomain: 'four-ways-au.firebaseapp.com',
  projectId: 'four-ways-au',
  storageBucket: 'four-ways-au.firebasestorage.app',
  messagingSenderId: '482966796376',
  appId: '1:482966796376:web:aac170cbdf667f7981722d',
  databaseURL: '',
};

// OAuth client id for Google sign-in. Separate from the config above because a
// project can be fully configured for sync while sign-in stays off.
// Set this after enabling Google sign-in in the four-ways-au Firebase Console.
export const googleClientId = '482966796376-2ke5h3coftc9pshetbjbhqrja1v0rln5.apps.googleusercontent.com';

export const isConfigured = () => !!(firebaseConfig.apiKey && firebaseConfig.projectId);
export const signInAvailable = () => isConfigured() && !!googleClientId;
